module.exports = __webpack_public_path__ + "static/img/7-3.05e47a23.png";